"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServerApi = void 0;
var tslib_1 = require("tslib");
var wix_experiments_1 = require("@wix/wix-experiments");
var services_1 = require("@wix/dealer-common/dist/src/services");
var HttpClient_1 = require("../HttpsClientApi/HttpClient");
var BannersApi_1 = require("../BannersApi/BannersApi");
var services_url_1 = require("../HttpsClientApi/services-url");
exports.ServerApi = {
    getDealerData: function (params) { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
        var newParams, _a, experiments, banners, bannerData, finalBannerData;
        return tslib_1.__generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    newParams = tslib_1.__assign(tslib_1.__assign({}, params), { limit: 1 });
                    return [4 /*yield*/, exports.ServerApi.getDealerDataNew(newParams)];
                case 1:
                    _a = _b.sent(), experiments = _a.experiments, banners = _a.banners;
                    bannerData = banners[0] || {};
                    finalBannerData = tslib_1.__assign(tslib_1.__assign({}, bannerData), { experiments: experiments });
                    if (!finalBannerData.asset) {
                        throw new Error('empty-data-dealer-content');
                    }
                    return [2 /*return*/, finalBannerData];
            }
        });
    }); },
    getDealerDataNew: function (params) { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
        var experimentsLoader, experimentsPromise, experiments, banners, response;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    experimentsLoader = new wix_experiments_1.default();
                    return [4 /*yield*/, experimentsLoader.load('dealer-client')];
                case 1:
                    _a.sent();
                    experimentsPromise = experimentsLoader
                        .ready()
                        .then(function () {
                        return experimentsLoader.all();
                    })
                        .catch(function () { return ({}); });
                    return [4 /*yield*/, experimentsPromise];
                case 2:
                    experiments = (_a.sent());
                    return [4 /*yield*/, BannersApi_1.BannersApi.getBanners(params)];
                case 3:
                    banners = _a.sent();
                    response = {
                        experiments: experiments,
                        banners: banners,
                    };
                    return [2 /*return*/, response];
            }
        });
    }); },
    getOffersData: function (_a, headers) {
        var _b = _a.excludeAssetIds, excludeAssetIds = _b === void 0 ? [] : _b, realEstateId = _a.realEstateId;
        var req = {
            excludeOfferIds: excludeAssetIds,
            realEstateId: realEstateId,
        };
        return HttpClient_1.HttpClientApi.doGet(services_url_1.OFFERS_SERVING, req, headers);
    },
    reportOfferEvent: function (params) {
        var request = params.request, signedInstance = params.signedInstance;
        if (!request.event.offerId) {
            return Promise.resolve({});
        }
        var headers = signedInstance ? { Authorization: signedInstance } : {};
        return HttpClient_1.HttpClientApi.doPost(services_url_1.REPORT_EVENT_URL(request.event.offerId), request, headers).catch(function (e) {
            services_1.reportSentryError(e, {
                realEstateId: request.event.realEstateId,
                eventType: request.event.type,
                offerId: request.event.offerId,
                dealerApiType: 'events',
                reportingClass: 'ServerApi.reportOfferEvent',
            });
        });
    },
};
//# sourceMappingURL=ServerApi.js.map